import { render } from "./faq-accordion.vue?vue&type=template&id=79c08676&scoped=true"
import script from "./faq-accordion.vue?vue&type=script&lang=js"
export * from "./faq-accordion.vue?vue&type=script&lang=js"

import "./faq-accordion.vue?vue&type=style&index=0&id=79c08676&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79c08676"]])

export default __exports__